import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import GuestSite from "@/pages/GuestSite";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCancelled from "@/pages/BookingCancelled";
import BookingApproval from "@/pages/BookingApproval";
import OfferAccept from "@/pages/OfferAccept";
import AddonAccept from "@/pages/AddonAccept";
import AddonSuccess from "@/pages/AddonSuccess";
import ReviewSubmit from "@/pages/ReviewSubmit";
import BalancePay from "@/pages/BalancePay";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import SmsTerms from "@/pages/SmsTerms";
import BusinessCard from "@/pages/BusinessCard";
import AffiliateSignup from "@/pages/AffiliateSignup";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<GuestSite />} />
            <Route path="/booking/success" element={<BookingSuccess />} />
            <Route path="/booking/cancelled" element={<BookingCancelled />} />
            <Route path="/approve/:token" element={<BookingApproval />} />
            <Route path="/offer/:token" element={<OfferAccept />} />
            <Route path="/addon/success" element={<AddonSuccess />} />
            <Route path="/addon/:token" element={<AddonAccept />} />
            <Route path="/review/:token" element={<ReviewSubmit />} />
            <Route path="/balance/:token" element={<BalancePay />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/sms" element={<SmsTerms />} />
            <Route path="/card/:code" element={<BusinessCard />} />
            <Route path="/join" element={<AffiliateSignup />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
